<template>
    <div class="w-full">
        <component
            :is="dialog.comp1"
            v-bind="{ ...dialog.props1 }"
            v-model="picker"
            @click:outside="validate(true)"
        >
            <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    ref="textField"
                    :disabled="disabled"
                    :label="label"
                    prepend-inner-icon="cake"
                    placeholder="mm/dd/yyyy"
                    v-bind="attrs"
                    v-on="on"
                    @input="[maskDate, (picker = false)]"
                    v-model="input"
                    outlined
                    dense
                    :error-messages="error"
                    :rules="rules"
                    :clearable="clearable"
                    maxlength="10"
                    :hide-details="hideDetails"
                    @click:clear="$emit('clear')"
                    :validate-on-blur="!!input"
                ></v-text-field>
            </template>
            <v-date-picker
                no-title
                next-icon="chevron_right"
                prev-icon="chevron_left"
                class="soli-round"
                v-model="selected"
                :active-picker.sync="activePicker"
                :min="min"
                :max="max ?? globalMomentISO(new Date())"
                :full-width="$vuetify.breakpoint.smAndDown"
                @input="picker = false"
                @change="saveBirthday"
            ></v-date-picker>
        </component>
    </div>
</template>

<script>
import { VMenu, VBottomSheet } from "vuetify/lib";
import globalMoment from "../../Mixins/GlobalMoment.js";

export default {
    mixins: [globalMoment],
    components: {
        VMenu,
        VBottomSheet,
    },
    data: function () {
        return {
            picker: null,
            activePicker: null,
            rules: [],
        };
    },
    props: {
        label: {
            type: String,
            default: "Birthday",
        },
        value: {
            type: String,
            default: "",
        },
        error: {
            type: String,
            default: "",
        },
        clearable: {
            type: Boolean,
            default: false,
        },
        required: {
            type: Boolean,
            default: false,
        },
        hideDetails: {
            type: [String, Boolean],
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        min: {
            type: String,
            default: "1900-01-01",
        },
        max: {
            type: String,
            default: null,
        },
    },
    computed: {
        dialog() {
            return {
                comp1: this.$vuetify.breakpoint.smAndDown
                    ? "v-bottom-sheet"
                    : "v-menu",
                props1: {
                    "close-on-content-click": false,
                    "nudge-right": "40",
                    "max-width": "450px",
                    "offset-y": true,
                    "min-width": "290px",
                    ref: "menu",
                },
            };
        },
        selected: {
            get() {
                if (!this.value || !moment(new Date(this.value)).isValid()) {
                    return null;
                }
                return new Date(this.value).toISOString().substr(0, 10);
            },
            set(value) {
                this.$emit("input", this.globalMomentUTCDate(value));
            },
        },
        input: {
            get() {
                return this.maskDate(this.value);
            },
            set(value) {
                if (value?.length == 10) this.$refs.textField.validate();
                this.$emit("input", value);
            },
        },
    },
    methods: {
        maskDate(value) {
            if (!value) return;
            let x = value
                .replace(/\D/g, "")
                .match(/(\d{0,2})(\d{0,2})(\d{0,4})/);
            return !x[2] ? x[1] : x[1] + "/" + x[2] + (x[3] ? "/" + x[3] : "");
        },
        saveBirthday(birthday) {
            this.$refs.menu.save(birthday);
        },
        validate(val) {
            if (!this.required || this.picker) {
                this.rules = [];
            } else {
                this.rules = val
                    ? [
                          (val) =>
                              ((val || "").length == 10 &&
                                  moment(new Date(val)).isValid() &&
                                  moment(new Date(val)) < moment()) ||
                              "Please enter a valid birthday",
                      ]
                    : [];
            }
            this.$nextTick(() => this.$refs.textField.validate());
        },
    },
    mounted() {
        this.$emit("mounted");
        this.validate(true);
    },
    watch: {
        picker(val) {
            val && setTimeout(() => (this.activePicker = "YEAR"));
            this.validate(!val);
        },
    },
};
</script>
